import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { PageContainerWithoutBackground } from '../PageContainerWithoutBackground';

export const SpinnerLayout = observer(function SpinnerLayout() {
	return (
		<PageContainerWithoutBackground>
			<Suspense fallback={<Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />}>
				<Outlet />
			</Suspense>
		</PageContainerWithoutBackground>
	);
});
